import colors from '../colors';
const colorModes = {
    actionBarTheme: {
        colors: {
            'page-gray': colors.plum,
            bluesuedeshoes: colors.white,
            black: colors.white,
        },
    },
    navigationMenuTheme: {
        colors: {
            bluesuedeshoes: colors.white,
            'light-gray': colors.plum,
            'patina-3': colors['slate-3'],
            'slate-5': colors.white,
        },
    },
};
export default colorModes;
//# sourceMappingURL=colorModes.js.map